module.exports = __webpack_public_path__ + "img/76151.feddb364.svg";